import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  progressReportTemplateFragment,
  organizationProgressReportTemplateFragment,
  progressReportFragment,
  courseProgressReportFragment,
  studentProgressReportFragment,
  organizationProgressReportGroupFragment,
  setProgressReportFragment,
  progressReportTaskGroupFragment,
} from "./ProgressReportFragments";

import {
  getCourseStudentProgressReportFeedQuery,
  getCourseStudentProgressReportFeedPaginatedQuery,
  getCourseStudentProgressReportFeedsQuery,
  getCourseStudentProgressReportIdsQuery,
  getCourseStudentProgressReportStatusDetailsQuery,
  getCourseStudentProgressReportBasicDetailsQuery,
  getCourseStudentProgressReportHeaderDetailsQuery,
  getCourseStudentProgressReportTemplateQuery,
  getProgressReportTemplateQuery,
  getProgressReportTemplateFeedQuery,
  getOrganizationProgressReportGroupFeedQuery,
  getOrganizationProgressReportGroupsQuery,
  getSetProgressReportFeedQuery,
  getProgressReportTemplatesQuery,
  getSubjectGroupWiseReportMetricsQuery,
  getOrganizationCourseFeedV1Query,
  getStudentsFromGradeQuery,
  getCourseProgressReportStudentsDetailQuery,
  getStaffCoursesQuery,
  getCourseProgressReportTaskBasicDetailsQuery,
  getProgressReportCourseSectionCompleteStatsQuery,
  getSubjectsDataQuery,
  getProgressReportTaskObjectivesQuery,
  getStudentReportPlannerElementNodesQuery,
  getCategorySetAssessmentRatingsQuery,
  getProgressReportAcademicTermQuery,
  getStudentIbGradeRatingsQuery,
  getAIPromptsForReportQuery,
  getStaffListQuery,
  getGradeListQuery,
  getSubjectListQuery,
  getProgressReportBaseTemplatesQuery,
  getAssociatedCoursesForPYPQuery,
  getOrganisationLanguageLocalesQuery,
  getAcademicYearTermsQuery,
  getAIVoiceTonesForCurriculumQuery,
  getStaffVoiceToneQuery,
  getStudentProgressReportRatingHistoryQuery,
  getProgressReportTaskGroupAcademicTermQuery,
  getCurriculumAttendanceOptionsForProgressReportQuery,
  getOrganizationMultiCurriculumAttendanceOptionsQuery,
  getStudentProgressReportDetailsQuery,
  getStudentProgressReportBasicDetailsQuery,
  getGradingCommentTemplatesQuery,
  getOrganizationGradesQuery,
  getOrganizationGradesWithGlobalGradeQuery,
  getPublishedStudentProgressReportDetailsQuery,
} from "./ProgressReportQuery";
import { getFlatUnitPlanFeedQuery } from "AppComponents/UnitSelection/modules/Queries";
import { getCreditsDetailsQuery } from "Login/routes/Administrator/commonComponents/GpaAndCredits/routes/CreditsSetup/routes/DefineSubjectCredits/modules/DefineSubjectCreditsQueries";
import { getGradeEntityProgressReportTaskDetailsQuery } from "AdminProgressReports/routes/ProgressReportTasks/modules/ProgressReportTaskQuery.js";

export const getProgressReportDetailsFromCache = ({ id, skipParam }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getProgressReportTemplateQuery,
      variables: {
        id,
        skipParam,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeProgressReportDetailsInCache = ({ id, data }) => {
  let queryData = {};

  try {
    queryData = client.writeFragment({
      id: `ProgressReportTemplate:${id}`,
      fragment: progressReportTemplateFragment.progressReportTemplateDetails,
      fragmentName: "progressReportTemplateItem",
      data,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationProgressReportTemplateFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getProgressReportTemplateFeedQuery,
      variables: {
        organizationId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeOrganizationProgressReportTemplateInCache = ({
  organizationId,
  data,
  filters,
}) => {
  let queryData = {};

  try {
    queryData = client.writeFragment({
      id: `Organization:${organizationId}`,
      variables: {
        filters,
      },
      fragment:
        organizationProgressReportTemplateFragment.organizationProgressReportTemplate,
      fragmentName: "organizationProgressReportTemplateItem",
      data,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationProgressReportGroupInCache = ({
  organizationId,
  searchText,
  academicYearId,
  curriculumProgramIds,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationProgressReportGroupFeedQuery,
      variables: {
        organizationId,
        searchText,
        academicYearId,
        curriculumProgramIds,
      },
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationProgressReportGroupsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationProgressReportGroupsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getProgressReportAcademicTermInCache = params => {
  try {
    const queryData = client.readQuery({
      query: getProgressReportAcademicTermQuery,
      variables: params,
    });
    return queryData ? queryData : {};
  } catch (e) {
    console.warn(e);
    return {};
  }
};

export const getSetProgressReportsFromCache = ({ setId, searchText }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSetProgressReportFeedQuery,
      variables: {
        id: setId,
        searchText,
      },
    });
    // console.log("QUERY DATA", queryData);
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCategorySetAssessmentRatingsFromCache = ({
  academicCriteriaValueId,
  assessmentRatingFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCategorySetAssessmentRatingsQuery,
      variables: {
        academicCriteriaValueId,
        assessmentRatingFilters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getProgressReportFromCache = ({ progressReportId }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `CourseProgressReportTask:${progressReportId}`,
      fragment: progressReportFragment.progressReportFeed,
      fragmentName: "progressReportItem",
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getProgressReportTemplatesFromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getProgressReportTemplatesQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeOrganizationProgressReportGroupInCache = ({
  organizationId,
  data,
  searchText,
  academicYearId,
  curriculumProgramIds,
}) => {
  client.writeFragment({
    id: `Organization:${organizationId}`,
    fragment:
      organizationProgressReportGroupFragment.organizationProgressReportGroupItem,
    fragmentName: "organizationProgressReportGroupItem",
    variables: {
      searchText,
      academicYearId,
      curriculumProgramIds,
    },
    data,
  });
};

export const writeSetProgressReportsInCache = ({ setId, data, searchText }) => {
  client.writeFragment({
    id: `ProgressReportTaskGroup:${setId}`,
    fragment: setProgressReportFragment.setProgressReport,
    fragmentName: "setProgressReportFragmentItem",
    variables: {
      searchText,
    },
    data,
  });
};

export const writeSetFeedProgressReportsInCache = ({ setId, data }) => {
  client.writeFragment({
    id: `ProgressReportTaskGroup:${setId}`,
    fragment: progressReportTaskGroupFragment.ProgressReportTaskGroupFeed,
    fragmentName: "progressReportTaskGroupItem",
    data,
  });
};

export const getCourseProgressReportFeedCountInCache = ({ courseId }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Course:${courseId}`,
      fragment: courseProgressReportFragment.courseProgressReportFeedCount,
      fragmentName: "courseProgressReportItem",
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getCourseProgressReportFeedInCache = ({
  courseId,
  searchText,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Course:${courseId}`,
      fragment: courseProgressReportFragment.courseProgressReportFeed,
      fragmentName: "courseProgressReportItem",
      variables: {
        searchText: searchText,
      },
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getCourseStudentProgressReportFeedInCache = args => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentProgressReportFeedQuery,
      variables: args,
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseStudentProgressReportFeedPaginatedFromCache = args => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentProgressReportFeedPaginatedQuery,
      variables: args,
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseStudentProgressReportFeeds = ({
  reportIds,
  orderBy,
  orderByDirection,
  filters,
  courseFilters,
  orderByInput,
}) => {
  return async () => {
    const result = await client.query({
      query: getCourseStudentProgressReportFeedsQuery,
      variables: {
        reportIds,
        orderBy,
        orderByDirection,
        filters,
        courseFilters,
        orderByInput,
      },
      fetchPolicy: "network-only",
    });
    return _.get(result, "data.multiNode", []);
  };
};

export const getCourseStudentProgressReportIdsInCache = ({
  reportId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentProgressReportIdsQuery,
      variables: {
        reportId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseStudentProgressReportStatusDetailsFromCache = ({
  reportId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentProgressReportStatusDetailsQuery,
      variables: {
        reportId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseProgressReportStudentsDetailFromCache = ({
  reportId,
  filters,
  orderBy,
  orderByDirection,
  isSubjectObjectivesSelectedFilter,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseProgressReportStudentsDetailQuery,
      variables: {
        reportId,
        filters,
        orderBy,
        orderByDirection,
        isSubjectObjectivesSelectedFilter,
      },
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectGroupWiseReportMetricsFeedFromCache = ({
  reportId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectGroupWiseReportMetricsQuery,
      variables: {
        reportId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseStudentProgressReportBasicDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentProgressReportBasicDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getTemplateVersionFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGradeEntityProgressReportTaskDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null)
    return _.get(queryData, "node.template.version", "1.0");
  else return {};
};

export const getCourseStudentProgressReportHeaderDetailsFromCache = ({
  reportId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentProgressReportHeaderDetailsQuery,
      variables: {
        reportId,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectsDataFromCache = ({
  reportTaskId,
  param,
  filters,
  isCourseBased,
  isSubjectBased,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectsDataQuery,
      variables: {
        reportTaskId,
        param,
        filters,
        isCourseBased,
        isSubjectBased,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseStudentProgressReportTemplateFromCache = ({
  reportId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentProgressReportTemplateQuery,
      variables: {
        reportId,
      },
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentProgressReportBasicDetailsQueryDataFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentProgressReportBasicDetailsQuery,
      variables,
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
export const getStudentProgressReportDetailsQueryDataFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentProgressReportDetailsQuery,
      variables,
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCreditsDetailsQueryFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCreditsDetailsQuery,
      variables,
    });
  } catch (e) {
    // console.log(e);
    console.warn(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAllStudentStatusQueryDataFromCache = studentProgressReportId => {
  let fragmentData = {};
  try {
    fragmentData = client.readFragment({
      id: `StudentProgressReport:${studentProgressReportId}`,
      fragment:
        studentProgressReportFragment.studentProgressReportCompletionStatus,
      fragmentName: "studentProgressReportCompletionStatus",
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (fragmentData != null) return fragmentData;
  else return {};
};

export const writeStudentProgressReportCompletionStatusFragmentInCache = ({
  data,
  studentProgressReportId,
}) => {
  try {
    client.writeFragment({
      id: `StudentProgressReport:${studentProgressReportId}`,
      fragment:
        studentProgressReportFragment.studentProgressReportCompletionStatus,
      fragmentName: "studentProgressReportCompletionStatus",
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const writeStudentProgressReportDetailsInCache = ({
  studentProgressReportId,
  data,
  filterNodeIds,
  shouldFetchNewEntitiesOnly = false,
  shouldSkipGpaAssociatedData = false,
}) => {
  let queryData = {};
  try {
    queryData = client.writeQuery({
      query: getStudentProgressReportDetailsQuery,
      data: {
        node: data,
      },
      variables: {
        studentProgressReportId,
        ratingFilters: { nodeIds: filterNodeIds },
        remarkFilters: { nodeIds: filterNodeIds },
        shouldFetchNewEntitiesOnly,
        shouldSkipGpaAssociatedData,
      },
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const publishedStudentProgressReportFragmentFromCache = ({
  studentId,
  archivalState,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getPublishedStudentProgressReportDetailsQuery,
      variables: {
        studentId,
        archivalState,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", queryData);
  else return {};
};

export const getOrganizationCourseFeedV1FromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationCourseFeedV1Query,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getIndividualStudentProgressReportDetailsFromCache = ({
  studentProgressReportId,
  userArchivedFilters,
  courseFilters,
}) => {
  let fragmentData = {};
  try {
    fragmentData = client.readFragment({
      id: `StudentProgressReport:${studentProgressReportId}`,
      fragment: studentProgressReportFragment.studentProgressReportFeed,
      fragmentName: "studentProgressReportItem",
      variables: {
        userArchivedFilters,
        courseFilters,
      },
    });
  } catch (e) {
    return {};
  }
  return fragmentData;
};

export const writeIndividualStudentProgressReportDetailsInCache = ({
  studentProgressReportId,
  data,
  userArchivedFilters,
  courseFilters,
}) => {
  try {
    client.writeFragment({
      id: `StudentProgressReport:${studentProgressReportId}`,
      fragment: studentProgressReportFragment.studentProgressReportFeed,
      fragmentName: "studentProgressReportItem",
      data,
      variables: {
        userArchivedFilters,
        courseFilters,
      },
    });
  } catch (e) {
    return {};
  }
};

export const getStudentsFromGradeFromCache = args => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentsFromGradeQuery,
      variables: args,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStaffCoursesFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffCoursesQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseProgressReportTaskBasicDetailsFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseProgressReportTaskBasicDetailsQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getProgressReportCourseSectionCompleteStatsFromCache = ({
  id,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProgressReportCourseSectionCompleteStatsQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getProgressReportTaskObjectivesFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProgressReportTaskObjectivesQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getProgressReportTaskGroupAcademicTermFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProgressReportTaskGroupAcademicTermQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentReportPlannerElementNodesFromCache = ({
  studentProgressReportId,
  associatedChildPlannerElementFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentReportPlannerElementNodesQuery,
      variables: {
        studentProgressReportId: studentProgressReportId,
        associatedChildPlannerElementFilters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeStudentProgressReportBasicDetailsToCache = ({
  data,
  variables,
}) => {
  try {
    client.writeQuery({
      query: getStudentProgressReportBasicDetailsQuery,
      variables,
      data,
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};
export const writeStudentProgressReportDetailsQueryToCache = ({
  data,
  variables,
}) => {
  try {
    client.writeQuery({
      query: getStudentProgressReportDetailsQuery,
      variables,
      data,
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};

export const getStudentIbGradeRatingsFromCache = ({
  id,
  filtersForRatingHistory,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentIbGradeRatingsQuery,
      variables: {
        id,
        filtersForRatingHistory,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getAIPromptsForReportsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAIPromptsForReportQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "ai", {});
};

export const getOrganizationStaffFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffListQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  return queryData;
};

export const getOrganizationGradesFromCache = ({
  organizationId,
  GradeFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGradeListQuery,
      variables: {
        organizationId,
        GradeFilters,
      },
    });
  } catch (e) {
    return {};
  }

  return queryData;
};

export const getOrganizationSubjectsFromCache = ({
  organizationId,
  SubjectFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectListQuery,
      variables: {
        organizationId,
        SubjectFilters,
      },
    });
    return queryData;
  } catch (e) {
    return {};
  }
};

export const getProgressReportBaseTemplatesFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProgressReportBaseTemplatesQuery,
      variables: {
        organizationId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getAssociatedCoursesForPYPFromCache = ({ reportId }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssociatedCoursesForPYPQuery,
      variables: {
        id: reportId,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganisationLanguageLocalesFromCache = ({
  organizationId,
  curriculumIds,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganisationLanguageLocalesQuery,
      variables: {
        organizationId,
        curriculumIds,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAcademicYearTermsFromCache = params => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAcademicYearTermsQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return _.get(queryData, "node", {});
};

export const writeAIVoiceTonesForReportsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAIVoiceTonesForCurriculumQuery,
      variables,
      data: {
        node: {
          ...data,
          __typename: "Organization",
        },
      },
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};

export const getAIVoiceTonesForReportsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery(
      {
        query: getAIVoiceTonesForCurriculumQuery,
        variables,
      },
      true
    );
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getStaffVoiceToneFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffVoiceToneQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeStaffVoiceToneToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getStaffVoiceToneQuery,
      variables,
      data: {
        node: {
          ...data,
          __typename: "Staff",
        },
      },
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};

export const getStudentProgressReportRatingHistoryFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getStudentProgressReportRatingHistoryQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getCurriculumAttendanceOptionsForProgressReportQueryFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCurriculumAttendanceOptionsForProgressReportQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return queryData ? queryData : {};
};

export const getOrganizationMultiCurriculumAttendanceOptionsQueryFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationMultiCurriculumAttendanceOptionsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return queryData ? queryData : {};
};

export const getFlatUnitPlanFeedFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getFlatUnitPlanFeedQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return queryData ? queryData : {};
};

export const getCommentTemplatesFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery(
      {
        query: getGradingCommentTemplatesQuery,
        variables,
      },
      true
    );
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const writeCommentTemplatesToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getGradingCommentTemplatesQuery,
      variables,
      data: {
        node: data,
      },
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};

export const getOrganizationGradesQueryFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery(
      {
        query: getOrganizationGradesQuery,
        variables,
      },
      true
    );
  } catch (e) {
    return {};
  }
  return _.get(queryData, "multiNode", {});
};

export const getOrganizationGradesWithGlobalGradeQueryFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery(
      {
        query: getOrganizationGradesWithGlobalGradeQuery,
        variables,
      },
      true
    );
  } catch (e) {
    return {};
  }
  return _.get(queryData, "multiNode", {});
};
